import { useState } from "react";
import { supabase } from "./supabaseclient";
import logo from "./logo.png";
import "./Login.css";

export default function StartReset() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); setErr(""); setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke("send-reset", { body: { email } });
      if (error) throw new Error(error.message || "Failed");
      if (!data?.ok) throw new Error(data?.error || "Failed");
      setMsg("If that email exists, a reset link has been sent.");
    } catch (ex) {
      setErr("Failed to send reset. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <form onSubmit={submit} className="login-card">
        <img src={logo} alt="Logo" className="logo" />
        <h2 className="login-title">Triple W Storage</h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          required
        />

        {err && <div className="err">{err}</div>}
        {msg && <div className="msg">{msg}</div>}

        <button disabled={loading || !email}>
          {loading ? "Sending…" : "Send reset link"}
        </button>

        <a href="/login" className="muted-link">Back to sign in</a>
      </form>
    </div>
  );
}
